/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskWorkflowItemConfigurationTargeting } from './TaskWorkflowItemConfigurationTargeting';
import {
    TaskWorkflowItemConfigurationTargetingFromJSON,
    TaskWorkflowItemConfigurationTargetingFromJSONTyped,
    TaskWorkflowItemConfigurationTargetingToJSON,
    TaskWorkflowItemConfigurationTargetingToJSONTyped,
} from './TaskWorkflowItemConfigurationTargeting';

/**
 * 
 * @export
 * @interface TaskWorkflowItemConfiguration
 */
export interface TaskWorkflowItemConfiguration {
    /**
     * 
     */
    id: string;
    /**
     * Master item id; null for a custom organization item.
     */
    task_workflow_item_id: string | null;
    /**
     * Current master item name; null for a custom organization item.
     */
    master_name: string | null;
    /**
     * Resolved display name (display_name_override, else master_name).
     */
    name: string;
    /**
     * 
     */
    display_name_override: string | null;
    /**
     * 
     */
    targeting: TaskWorkflowItemConfigurationTargeting;
    /**
     * 
     */
    auto_add_to_new_referrals: boolean;
    /**
     * 
     */
    display_order: number;
}

/**
 * Check if a given object implements the TaskWorkflowItemConfiguration interface.
 */
export function instanceOfTaskWorkflowItemConfiguration(value: object): value is TaskWorkflowItemConfiguration {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('task_workflow_item_id' in value) || value['task_workflow_item_id'] === undefined) return false;
    if (!('master_name' in value) || value['master_name'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('display_name_override' in value) || value['display_name_override'] === undefined) return false;
    if (!('targeting' in value) || value['targeting'] === undefined) return false;
    if (!('auto_add_to_new_referrals' in value) || value['auto_add_to_new_referrals'] === undefined) return false;
    if (!('display_order' in value) || value['display_order'] === undefined) return false;
    return true;
}

export function TaskWorkflowItemConfigurationFromJSON(json: any): TaskWorkflowItemConfiguration {
    return TaskWorkflowItemConfigurationFromJSONTyped(json, false);
}

export function TaskWorkflowItemConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskWorkflowItemConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'task_workflow_item_id': json['task_workflow_item_id'],
        'master_name': json['master_name'],
        'name': json['name'],
        'display_name_override': json['display_name_override'],
        'targeting': TaskWorkflowItemConfigurationTargetingFromJSON(json['targeting']),
        'auto_add_to_new_referrals': json['auto_add_to_new_referrals'],
        'display_order': json['display_order'],
    };
}

export function TaskWorkflowItemConfigurationToJSON(json: any): TaskWorkflowItemConfiguration {
    return TaskWorkflowItemConfigurationToJSONTyped(json, false);
}

export function TaskWorkflowItemConfigurationToJSONTyped(value?: TaskWorkflowItemConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'task_workflow_item_id': value['task_workflow_item_id'],
        'master_name': value['master_name'],
        'name': value['name'],
        'display_name_override': value['display_name_override'],
        'targeting': TaskWorkflowItemConfigurationTargetingToJSON(value['targeting']),
        'auto_add_to_new_referrals': value['auto_add_to_new_referrals'],
        'display_order': value['display_order'],
    };
}

